import React                     from "react"
import {Box, Typography, useTheme} from "@mui/material"
import StudyScreenActions         from "./StudyScreenActions"

/*
 * Topic intro — the full-screen card shown before the first question of a topic (078).
 * Deliberately the same shape as the topic score screen at the other end of the topic:
 * centred content on the page itself, no panel, and the same two actions.
 */
const TopicTitle = ({topic, parentTopics, onContinue, onDashboard}) => {

	const custom = useTheme().custom

	const path = parentTopics && parentTopics.length ? parentTopics.join(' / ') : null

	return (
		<Box
			display="flex"
			flex={1}
			flexDirection="column"
			justifyContent="center"
			alignItems="center"
			width="100%"
			px={{xs: 2, sm: 4}}
			py={4}
		>
			<Box sx={{maxWidth: 900, width: '100%', textAlign: 'center'}}>
				{path && (
					<Typography sx={{
						fontSize: custom.fontSize.md,
						color: custom.text.muted,
						mb: 1,
					}}>
						{path}
					</Typography>
				)}

				<Typography sx={{
					fontSize: {xs: 32, md: 48},
					fontWeight: custom.fontWeight.bold,
					color: custom.text.main,
					lineHeight: 1.15,
				}}>
					{topic.name}
				</Typography>

				<Box sx={{mt: 5, display: 'flex', justifyContent: 'center'}}>
					<StudyScreenActions onContinue={onContinue} onDashboard={onDashboard}/>
				</Box>
			</Box>
		</Box>
	)
}

export default TopicTitle
